import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import clockGreyIcon from 'assets/images/icons/clock-grey.svg';
import chevronGreyIcon from 'assets/images/icons/chevron-grey.svg';
import TimeSpinnerInput from './TimeSpinnerInput';
import DropdownWrapper from './DropdownWrapper';
import { displayISOTo12HourString } from 'components/utils';
import { useTranslation } from 'react-i18next';

const TimePickerDropdown = ({
  name,
  label,
  value,
  classes,
  format12Hour,
  onChange,
  defaultTime,
  mountTarget,
  align,
}) => {
  const ref = useRef();
  const { t } = useTranslation();

  const handleTime = () => {
    const time = ref.current?.getTime();
    if (!time) return;
    onChange(name, time);
  };

  return (
    <div>
      <DropdownWrapper
        toggleClasses={`d-flex gap-2 align-items-center cursor-pointer ${classes ?? ''}`}
        toggleComponent={
          <>
            <img src={clockGreyIcon} />
            <span>{value ? displayISOTo12HourString(value) : t('text_select_time')}</span>
            <img src={chevronGreyIcon} className='rotate-180' />
          </>
        }
        dropdownContent={({ handleCloseDropdown }) => (
          <div className='px-3 py-1 d-flex flex-column gap-3'>
            <div>
              {label && <div className='lh-1 theme-size-1_1 mb-2'>{label}</div>}
              <TimeSpinnerInput
                ref={ref}
                value={value}
                format12Hour={format12Hour}
                defaultTime={defaultTime}
              />
            </div>

            <div className='d-flex justify-content-end gap-3'>
              <div
                className='theme-button-white-1 px-2 py-1 rounded-sm cursor-pointer'
                onClick={handleCloseDropdown}
              >
                Close
              </div>
              <div
                className='theme-button-green-1 px-2 py-1 rounded-sm cursor-pointer'
                onClick={() => {
                  handleTime();
                  handleCloseDropdown();
                }}
              >
                Done
              </div>
            </div>
          </div>
        )}
        mountTarget={mountTarget}
        align={align}
        // fullWidth
      />
    </div>
  );
};

TimePickerDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  classes: PropTypes.string,
  format12Hour: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  defaultTime: PropTypes.string,
  mountTarget: PropTypes.string,
  align: PropTypes.string,
};

export default TimePickerDropdown;
